import React from 'react';
import styled from 'styled-components';

const Container = styled.footer`
  margin-top: 80px;
  padding: 40px 0 20px;
  background: #0a0e27;
  border-top: 1px solid #2d3561;
`;

const Content = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
`;

const PartnerSection = styled.div`
  text-align: center;
  margin-bottom: 30px;
`;

const PartnerTitle = styled.h3`
  font-size: 1.2em;
  color: #667eea;
  margin-bottom: 20px;
`;

const PartnerGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 15px;
  margin-bottom: 30px;
`;

const PartnerLink = styled.a`
  background: #1a1f3a;
  padding: 15px;
  border-radius: 10px;
  text-decoration: none;
  color: #e0e6ed;
  transition: all 0.3s ease;
  border: 1px solid #2d3561;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.9em;
  
  &:hover {
    background: #2d3561;
    border-color: #667eea;
    transform: translateY(-2px);
    box-shadow: 0 5px 15px rgba(102, 126, 234, 0.3);
  }
`;

const FooterNote = styled.div`
  text-align: center;
  font-size: 0.85em;
  color: #8892b0;
  padding-top: 20px;
  border-top: 1px solid #2d3561;
`;

const Footer = () => {
  const partners = [
    {
      name: 'QuantumSecurity.ai',
      url: 'https://quantumsecurity.ai/'
    },
    {
      name: 'CISOMarketplace',
      url: 'https://cisomarketplace.com/'
    },
    {
      name: 'AI Risk Assessment',
      url: 'https://airiskassess.com/'
    },
    {
      name: 'Global Compliance Map',
      url: 'https://globalcompliancemap.com/'
    },
    {
      name: 'Zero Trust CISO',
      url: 'https://zerotrustciso.com'
    },
    {
      name: 'SOC2 Compliance',
      url: 'https://socassessment.com/'
    },
    {
      name: 'IRM Maturity Assessment',
      url: 'https://irmaturityassessment.com/'
    },
    {
      name: 'DevSecOps Hub',
      url: 'https://devsecops.vibehack.dev/'
    },
    {
      name: 'EU Compliance Mapping',
      url: 'http://eumapping.compliancehub.wiki/'
    },
    {
      name: 'Compliance Baseline',
      url: 'https://baseline.compliancehub.wiki/'
    },
    {
      name: 'Cyber Agent Exchange',
      url: 'https://prompts.cyberagent.exchange/'
    },
    {
      name: 'VibeHack Dev',
      url: 'https://vibehack.dev/'
    }
  ];
  
  return (
    <Container>
      <Content>
        <PartnerSection>
          <PartnerTitle>🤝 Partner Security Tools & Resources</PartnerTitle>
          <PartnerGrid>
            {partners.map((partner, index) => (
              <PartnerLink 
                key={index} 
                href={partner.url} 
                target="_blank"
                rel="noopener noreferrer"
              >
                {partner.name}
              </PartnerLink>
            ))}
          </PartnerGrid>
        </PartnerSection>
        
        <FooterNote>
          <p>🛡️ Cloud Security Configuration Checker v3.0 | 2026 Edition | Aligned with CSA CCM v4, NIST CSF 2.0, DORA, NIS2 & more | No cloud access required</p>
          <p style={{ marginTop: '10px' }}>
            This tool provides guidance based on security best practices. Always consult with security professionals for your specific requirements.
          </p>
        </FooterNote>
      </Content>
    </Container>
  );
};

export default Footer; 